var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState, } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { space, layout, } from 'styled-system';
export function Illustration(_a) {
    var { name, className = '' } = _a, props = __rest(_a, ["name", "className"]);
    const [illustration, set] = useState('');
    const url = useMemo(() => {
        var _a, _b;
        // eslint-disable-next-line
        // @ts-ignore
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.env) === null || _a === void 0 ? void 0 : _a.ASSETS) === null || _b === void 0 ? void 0 : _b.includes('assets-t')) {
            return 'https://assets-t.storebrand.no/illustrations/';
        }
        return 'https://assets.storebrand.no/illustrations/';
    }, []);
    const combinedClassName = `illustration illustration-${name} ${className}`;
    useEffect(() => {
        const source = axios.CancelToken.source();
        const { href } = new URL(`${name}.svg`, url);
        axios.get(href, { cancelToken: source.token })
            .then((response) => set(response.data))
            .catch((error) => {
            if (!axios.isCancel(error)) {
                set(`Can't find an icon with name ${name}!`);
            }
        });
        return () => source.cancel('Canceling in cleanup');
    }, [name, url]);
    return (React.createElement(IllustrationBase, Object.assign({ className: combinedClassName, dangerouslySetInnerHTML: { __html: illustration } }, props)));
}
export const IllustrationBase = styled.div `
  display: inline-flex;

  & > svg {
    width: 100%;
    height: 100%;
  }

  ${space};
  ${layout};
`;
export default Illustration;
